module.exports = __webpack_public_path__ + "static/media/smallEmptyState.4f3574b2.svg";